<p-dialog
  styleClass="subscription-nudge-dialog"
  [closable]="true"
  [closeOnEscape]="true"
  [modal]="true"
  [dismissableMask]="false"
  [(visible)]="isVisible"
  (onHide)="data = undefined">
  <div class="flex-col gap-2">
    <p-message
      [closable]="false"
      icon="fas fa-exclamation-triangle"
      severity="warn"
      [text]="'ATTENTION NEEDED: SUBSCRIPTION INACTIVE' | translate">
    </p-message>

    <div class="dialog-text flex-col gap-2">
      <p>
        {{ 'Miradi only exists through support from users like you. If you wish to continue editing content in Miradi, please subscribe to help our community advance conservation worldwide.' | translate }}
      </p>
      @if (showPricingPageLink) {
        <p>
          {{ 'Subscription options are listed on the' | translate }}
          <a (click)="persistAndDismiss('/subscriptions')"
            href="javascript: void(0);"
            tabIndex="0">
            {{ 'Pricing page' | translate }}.
          </a>
        </p>
      }
    </div>
  </div>

  <ng-template #footer>
    <p-button
      (click)="persistAndDismiss(null)"
      [label]="'Remind me later' | translate"
      [text]="true">
    </p-button>

    @if (showSubscriptionStatusButton) {
      <p-button
        (click)="persistAndDismiss('/account')"
        [label]="'View subscription status' | translate"
        [raised]="true"
        severity="primary">
      </p-button>
    }
  </ng-template>
</p-dialog>
